<p>detail-attendance works!</p>
